export default "__VITE_ASSET__Bt4jhNyi__"